



















































import { Vue, Component, Prop, VModel } from 'vue-property-decorator'

const TRUNCATE_LENGTH = 4

type WeekDay = {
  name: string
  order: number
}

@Component
export default class WeekDayPicker extends Vue {
  @VModel() model!: Array<number>

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  get weekDays(): Array<WeekDay> {
    return [ 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday' ].map((name, index) => ({
      name: this.truncate(this.$t(`week_day_picker_${ name }_title`) as string),
      order: index + 1,
    }))
  }

  get sunday(): WeekDay | undefined {
    return [ ...this.weekDays ].pop()
  }

  get numericModel():Array<number> {
    return [ ...this.model ].map((v) => Number.parseInt(v as unknown as string, 10))
  }

  truncate(value: string): string {
    return value.slice(0, TRUNCATE_LENGTH)
  }

  toggleButton(weekDay: WeekDay): void {
    if (!this.disabled) {
      if (this.numericModel.includes(weekDay.order)) {
        this.model = this.numericModel.filter((orderItem, index): boolean => index !== this.model.indexOf(weekDay.order))
      } else {
        this.model = [ ...this.numericModel, weekDay.order ]
      }
    }
  }

  created(): void {
    this.$i18n.mergeLocaleMessage('ru', {
      week_day_picker_monday_title: 'Пн',
      week_day_picker_tuesday_title: 'Вт',
      week_day_picker_wednesday_title: 'Ср',
      week_day_picker_thursday_title: 'Чт',
      week_day_picker_friday_title: 'Пт',
      week_day_picker_saturday_title: 'Сб',
      week_day_picker_sunday_title: 'Вс',
    })
    this.$i18n.mergeLocaleMessage('en', {
      week_day_picker_monday_title: 'Mo',
      week_day_picker_tuesday_title: 'Tu',
      week_day_picker_wednesday_title: 'We',
      week_day_picker_thursday_title: 'Th',
      week_day_picker_friday_title: 'Fr',
      week_day_picker_saturday_title: 'Sa',
      week_day_picker_sunday_title: 'Su',
    })
  }
}

